import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getToken } from "../../helpers";
import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

export const fetchProducts = createAsyncThunk(
  "product/fetchProducts",
  async (_, { rejectWithValue }) => {
    try {
      const token = await getToken();

      if (!token) {
        console.error("Токен не найден");
        return rejectWithValue("Токен не найден");
      }

      const axiosInstance = axios.create({
        baseURL: API_URL,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const response = await axiosInstance.get(`/products/owner`);

      if (!response.data) {
        console.error("Нет данных в ответе");
        return rejectWithValue("Нет данных");
      }

      return response.data;
    } catch (error) {
      console.error("Ошибка при запросе:", error);
      return rejectWithValue(error.response?.data || "Ошибка сервера");
    }
  }
);

export const createProduct = createAsyncThunk(
  "product/createProduct",
  async (productData, { rejectWithValue }) => {
    try {
      const token = await getToken();

      if (!token) {
        console.error("Токен не найден");
        return rejectWithValue("Токен не найден");
      }

      const axiosInstance = axios.create({
        baseURL: API_URL,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const response = await axiosInstance.post(`/products`, productData);

      if (!response.data) {
        console.error("Ошибка: сервер не вернул данные");
        return rejectWithValue("Ошибка при создании продукта");
      }

      return response.data;
    } catch (error) {
      console.error("Ошибка при создании продукта:", error);
      return rejectWithValue(error.response?.data || "Ошибка сервера");
    }
  }
);

export const updateProduct = createAsyncThunk(
  "product/updateProduct",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = await getToken();

      if (!token) {
        console.error("Токен не найден");
        return rejectWithValue("Токен не найден");
      }

      const axiosInstance = axios.create({
        baseURL: API_URL,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const response = await axiosInstance.patch(`/products/${id}`, data); // 👈 PATCH, не PUT

      return response.data;
    } catch (error) {
      console.error("Ошибка при обновлении:", error);
      return rejectWithValue(error.response?.data || "Ошибка сервера");
    }
  }
);

export const deleteProduct = createAsyncThunk(
  "product/deleteProduct",
  async (id, { rejectWithValue }) => {
    try {
      const token = await getToken();

      if (!token) {
        console.error("Токен не найден");
        return rejectWithValue("Токен не найден");
      }

      const axiosInstance = axios.create({
        baseURL: API_URL,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const response = await axiosInstance.delete(`/products/${id}`);

      if (!response.data) {
        console.error("Ошибка при удалении продукта");
        return rejectWithValue("Ошибка при удалении продукта");
      }

      return id;
    } catch (error) {
      console.error("Ошибка при удалении продукта:", error);
      return rejectWithValue(error.response?.data || "Ошибка сервера");
    }
  }
);

export const productSlice = createSlice({
  name: "product",
  initialState: {
    products: [],
    activeProduct: null,
    loading: false,
    error: null,
  },
  reducers: {
    setActiveProduct: (state, action) => {
      state.activeProduct = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateProduct.fulfilled, (state, action) => {
        const updated = action.payload;
        state.products = state.products.map((product) =>
          product.id === updated.id ? updated : product
        );
      })
      .addCase(deleteProduct.fulfilled, (state, action) => {
        state.products = state.products.filter(
          (product) => product.id !== action.payload
        );
      });
  },
});

export const { setOwner } = productSlice.actions;

export default productSlice.reducer;
